import {Button} from "@/components/ui/button";

interface CancelRdvButtonsProps {
  onSimpleDelete: () => void;
  onCancel: () => void;
  onAutoDelete: () => void;
  onPostPone: () => void;
  isSecretary: boolean;
}

const CancelRdvButtons = ({
  onSimpleDelete,
  onCancel,
  onAutoDelete,
  onPostPone,
  isSecretary,
}: CancelRdvButtonsProps) => {
  return (
    <div id="choix_motif_delete_rdv">
      {!isSecretary && (
        <Button
          type="button"
          id="rdv_delete"
          size="sm"
          onClick={onSimpleDelete}
        >
          Suppression simple
        </Button>
      )}
      <Button
        type="button"
        id="rdv_canceled"
        size="sm"
        variant="secondary"
        onClick={isSecretary ? onAutoDelete : onCancel}
      >
        Annulation
      </Button>
      <Button
        type="button"
        id="rdv_postponed"
        size="sm"
        variant="secondary"
        onClick={onPostPone}
      >
        Report
      </Button>
    </div>
  );
};
export default CancelRdvButtons;
